import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import { Icon } from "@sequentech/ui-essentials";
import { translate } from "@sequentech/ui-core";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
/**
 * How many candidates a contest holds, whether any choice is left unused, and
 * the way back to edit it.
 */
export var ReviewContestFooter = function (_a) {
    var _b;
    var contest = _a.contest, count = _a.count, to = _a.to;
    var _c = useTranslation(), t = _c.t, i18n = _c.i18n;
    var state = { editContestId: contest.id };
    var isUnfilled = count.selected < count.max;
    return (_jsxs(Box, { className: "review-contest-footer".concat(isUnfilled ? " review-contest-unfilled" : ""), sx: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "12px",
            margin: "12px 0",
            overflowWrap: "anywhere",
        }, children: [_jsxs(Box, { className: "review-contest-status", sx: { minWidth: 0 }, children: [_jsx(Typography, { className: "review-contest-count", variant: "body2", sx: { margin: 0, fontSize: "12px", color: "customGrey.dark" }, children: t("slates.review.contestCount", { selected: count.selected, max: count.max }) }), count.selected === 0 ? (_jsx(Typography, { className: "review-contest-blank", variant: "body2", sx: { margin: "2px 0 0", fontSize: "14px", color: "#8a6b23" }, children: t("slates.review.unfilled") })) : null] }), _jsx(Button, { className: "review-contest-edit", component: RouterLink, to: to, state: state, variant: "secondary", sx: { minHeight: "44px", minWidth: "44px", width: "44px", padding: "9px" }, "aria-label": t("slates.review.editLabel", {
                    contest: (_b = translate(contest, "name", i18n.language)) !== null && _b !== void 0 ? _b : "",
                }), children: _jsx(Icon, { className: "review-contest-edit-icon", icon: faPen, size: "sm" }) })] }));
};
